import axios from 'axios'
import Vue from 'vue';
import App from './index.vue';
import iview from 'iview';
import 'iview/dist/styles/iview.css'
import './styles/base.css';
//加载 基础版
import './../runtime-components/main-basic';
import bus from './utils/bus'
import * as authApi from "./api/auth";
import * as extlibApi from './api/extlib'
import {normalizeUrl} from './utils/utils';
import {libs} from './store';
import {name, components, datasets, functions}  from '@/editor-components/lib-config/index';

let innerLibConfig = {name, components, datasets, functions} ;
Vue.config.productionTip = false;
Vue.use(iview);
new Vue({
  render: (h) => h(App),
  mounted() {
    window._hmt.push(['_trackEvent', 'page', window.location.href]);
    authApi.getLoginInfo().then(()=>{
      this.loadPage();
    }).catch(()=>{
      authApi.login('daping','daping').then(()=>{
        this.loadPage();
      })
    })
  },

  methods: {
    loadPage(){
      let pageId = location.search.match(new RegExp("(/?|&)page=([^&]*)(&|$)"))[2];
      return axios.get(`/api/page/${pageId}`).then(resp=>{
        let config = JSON.parse(resp.data.result.config);
        if(resp.data.result&&resp.data.result.name){
          document.title = resp.data.result.name;
        }
        let localConfig = localStorage.getItem(`config-${config.code}`);
        if(localConfig){
          config = JSON.parse(localConfig);
        }
        this.cacheLibToStore('de', innerLibConfig);
        this.importExtLibs(config).then(()=>{
          bus.$emit('loadData', config);
        })
      })
    },

    importExtLibs(config){
      let extLibs = config.extLibs;
      if(extLibs&&extLibs.length){
        return Promise.all(extLibs.map(libId=>{
          return extlibApi.loadExtlib(libId).then((libConfig)=>{
            return this.importLib(normalizeUrl(libConfig.path)+libConfig.entryFileName).then((lib) => {
              Vue.use(lib, libConfig.prefix);
              this.cacheLibToStore(libConfig.prefix, lib.libConfig);
            });
          })
        }))
      }else{
        return Promise.resolve();
      }
    },

    importLib(entryFilePath){
      return new Promise((r,rj)=>{
          let lib = window.System.get(entryFilePath);
          if(lib){
              r(lib.default);
          }else{
              window.System.import(entryFilePath).then((lib,a,b,c)=>{
              r(lib.default);
              }).catch(e=>{
                  rj('加载库出错，请检查...');
              });
          }
      })
    },

    cacheLibToStore(prefix, lib){
      let componentsMap = {};
      let datasetsMap = {};
      let functionsMap = {};

      for (let i = 0; i < lib.components.length; i++) {
        const item = lib.components[i];
        componentsMap[item.tag] = item;
      }

      for (let i = 0; i < lib.functions.length; i++) {
        const item = lib.functions[i];
        functionsMap[item.func] = item;
      }

      for (let i = 0; i < lib.datasets.length; i++) {
        const item = lib.datasets[i];
        datasetsMap[item.name] = item;
      }

      libs[prefix] = {componentsMap, datasetsMap, functionsMap, ...lib}
    }
  },

}).$mount('#app');